import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {CLStore} from 'common/src/redux/store';
import {weightedCardSchema} from '../../schemas/weightedCardSchema';
import addOrUpdateCardTool from '../general/addOrUpdateCardTool/addOrUpdateCardTool';
import getFilesTool from 'common/src/modules/shared/copilot/tools/getFilesTool';
import readValuesFromExcelTool from '../general/readValuesFromExcelTool/readValuesFromExcelTool';

export default function addOrUpdateWeightedCardTool(store: CLStore) {
  return addOrUpdateCardTool({
    store,
    cardType: NodeType.WEIGHTED,
    cardSchema: weightedCardSchema,
    tools: [getFilesTool(), readValuesFromExcelTool()],
    cardSpecificInstructions:
      'Set the "shouldSplitAudience" field to true if the user requests to split the audience/ audience split/ audience split A/B testing and similar phrases, otherwise set it to false. Capable of reading values from an excel file',
  });
}
